// extracted by css-extract-rspack-plugin
export default {"tokenText":"HeaderIssueType-module__tokenText__iKy6B","smallToken":"HeaderIssueType-module__smallToken__p4_yv","IssueTypeToken":"HeaderIssueType-module__IssueTypeToken__kzI7i"};